import React, { useMemo, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import TotalTaskTable from './table/TotalTaskTable';
import useFetchTotalTask from './hooks/useFetchTotalTask';
import useFetchClassRefRecords from '../../MyTime/hooks/useFetchClassRefs';
import useFetchCustomerRefRecords from '../../MyTime/hooks/useFetchCustomerRefs';
import AddTaskDialog from '../../MyTask/dialog/AddTaskDialog';

const useStyles = makeStyles((theme) => ({
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: '1.4rem',
    margin: 0
  },
  tabsWrapper: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2)
  },
  tab: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.95rem'
  }
}));

const TotalTask = () => {
  const classes = useStyles();

  const [addTaskOpen, setAddTaskOpen] = useState(false);

  // Total task: created/assigned and all
  const { totalTaskRows, setTotalTaskRows, totalTaskLoading } = useFetchTotalTask();
  const [totalTaskSelection, setTotalTaskSelection] = useState([]);

  //fetch class from qbo
  const { classRefs } = useFetchClassRefRecords();
  const { customerRefs } = useFetchCustomerRefRecords();

  const dependencyOptions = useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return totalTaskRows
      .filter((row) => {
        const dueDate = new Date(row?._raw?.dueDate || row.dueDate);
        return !Number.isNaN(dueDate.getTime()) && dueDate >= today;
      })
      .map((row) => ({
        value: row.id,
        label: row.title || `Task ${String(row.id).slice(-8)}`,
        dependencyIds: row.dependencyIds || []
      }));
  }, [totalTaskRows]);

  const handleAddTask = () => setAddTaskOpen(true);

  // When a new task is created, add it to both tables (it may appear in both tabs)
  const handleSetRows = (updater) => {
    setTotalTaskRows(updater);
  };

  return (
    <div className="tw-mt-6">
      {/* Page header */}
      <div className={classes.pageHeader}>
        <h2 className={classes.pageTitle}>Total Tasks</h2>
      </div>

      {/* Add Task Dialog */}
      {addTaskOpen && (
        <AddTaskDialog
          open={addTaskOpen}
          setOpen={setAddTaskOpen}
          setRows={handleSetRows}
          classRecords={classRefs}
          customerRecords={customerRefs}
          dependencyOptions={dependencyOptions}
          taskSource="totalTask"
        />
      )}

      <TotalTaskTable
        rows={totalTaskRows}
        setRows={setTotalTaskRows}
        selection={totalTaskSelection}
        setSelection={setTotalTaskSelection}
        loading={totalTaskLoading}
        classRecords={classRefs}
        onAddTask={handleAddTask}
      />
    </div>
  );
};

export default TotalTask;
